module.exports = __webpack_public_path__ + "e4596ae242a871364ac575b7c07dd192.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/coffee-table.png
// module id = 973
// module chunks = 0